module.exports = __webpack_public_path__ + "static/media/Web-Development@2x.25f4a537.png";